import { appUserStore } from '@stores/bootstrap-stores/user';
import { hasKeys } from '@utils/vanillaJs';
import { ISOLanguageCode } from '@vincerosoft/assessfluence-types';

export function translateKey(
  translationKey:
    | string
    | {
        [key in ISOLanguageCode | 'default']?: string;
      }
): string {
  const userLangPreference = appUserStore.getState()?.appUser?.system_language || 'en';

  if (!translationKey) {
    return '';
  }

  if (typeof translationKey === 'string') {
    return translationKey;
  }

  const nameObj = translationKey as { [key in ISOLanguageCode | 'default']?: string };

  return userLangPreference && hasKeys(nameObj) && nameObj[userLangPreference]
    ? nameObj[userLangPreference]
    : (nameObj['default'] ?? '');
}
